import React, { useState } from 'react';
import { Button } from '../../button/index.js';
import { Checkbox, mapCheckedToCheckboxStatus } from '../../checkbox/index.js';
import { MaterialIcon } from '../../material-icon/index.js';
import styles from './MaterialAssignmentRow.module.css.js';

function MaterialAssignmentRow({ material, onOpenMaterial, markAsDone, isDone, translations, }) {
    const [disabled, setDisabled] = useState(true);
    const { id, name, contentType } = material;
    const onClick = () => {
        onOpenMaterial(material);
        if (!isDone)
            setDisabled(false);
    };
    return (React.createElement("div", { className: styles.container, id: 'material-assignment-row' },
        React.createElement(MaterialIcon, { contentType: contentType, materialType: material.type, className: styles.icon }),
        React.createElement("div", { title: name, className: styles.materialText }, name),
        material.href ? (React.createElement("a", { className: 'bc-button__button bc-button__primary bc-button__small bc-button__outline', onClick: onClick, href: material.href, target: '_blank', rel: 'noopener noreferrer' }, translations.open)) : (React.createElement(Button, { size: 'small', onClick: onClick, outline: true, variant: 'primary' }, translations.open)),
        React.createElement("label", { htmlFor: `is-done--${id}`, className: styles.isReadyContainer },
            React.createElement("span", { className: styles.isReadyText }, translations.isDone),
            React.createElement(Checkbox, { name: `is-done--${id}`, id: `is-done--${id}`, value: `is-done--${id}`, status: mapCheckedToCheckboxStatus(isDone), size: 'large', variant: 'rounded', onChange: () => markAsDone(material.id), disabled: disabled }))));
}

export { MaterialAssignmentRow };
